export default function getPrice(upcomingInvoice: any, upcomingInvoiceItem: any, applyCouponToPrice: any) {
    return (+applyCouponToPrice(upcomingInvoiceItem.price.unit_amount, upcomingInvoice?.discount ? {coupon: upcomingInvoice.discount.coupon} : undefined)/100).toFixed(2)
}